import { gql } from '@apollo/client';

/** Public receipt bill — no auth. Keep fields in sync with getBill in Order.graphql. */
export const GET_PATRON_RECEIPT_BILL = gql`
	query getPatronReceiptBill($billID: String!, $outletID: String) {
		getPatronReceiptBill(billID: $billID, outletID: $outletID) {
			ID
			outletID
			createdBy
			modBy
			outlet {
				name
				logo
				address
				contactNo
				currencyCode
				integrate3rdPartyeInvoice
				registrationNo
				taxSchemeID
				taxRegistrationNo
				isRetail
				outletChannel {
					ID
					hotelID
					name
				}
				company {
					id
					name
					companyRegNo
					sstNo
					gstNo
					tin
					isEInvIntegrated
					eInvStartDate
					eInvEndDate
					address {
						address
						address2
						city
						state
						postCode
						country
					}
				}
			}
			createdTs
			billNo
			signature
			orderID
			status
			qrCodeUrl
			is_einvoice
			einvoice_irbm_uniqueID
			order {
				ID
				docNo
				patronAccountID
				pax
				patronName
				patronID
				taxSchemeInfo
				taxSchemeFooterInfo
				orderDiscount {
					ID
					discountID
					amount
					status
					reasonCode
					remark
				}
				table {
					ID
					tableNumber
					prefix
					status
				}
				patron {
					patronClass
				}
				serviceMode
				orderItem {
					ID
					billID
				}
			}
			payments {
				ID
				amount
				registrationID
				receivedAmount
				changeAmount
				roundingAmount
				businessDate
				cardNo
				reasonCode
				creditCardType
				paymentClass
				referenceNo
				patronAccountID
				hotelGuestInfo
				defaultPayment {
					ID
					paymentClass
					paymentTypeInfo
				}
				status
				remark
				createdTs
			}
			orderItem {
				ID
				amount
				refID
				serviceCharge
				taxAmount
				totalInfo
				quantity
				openItemName
				menuItem {
					ID
					name
				}
				orderItemOption {
					ID
					name
					orderItemID
					orderItemOptionItem {
						ID
						price
						unitPrice
						optionItem {
							name
						}
					}
				}
				orderItemSetMenuOption {
					ID
					orderItemSetMenuOptionItem {
						menuItem {
							name
						}
						setMenuOptionItem {
							menuItem {
								name
							}
						}
					}
				}
			}
		}
	}
`;
